export default "__VITE_ASSET__FNGyUd2a__"